module.exports = __webpack_public_path__ + "static/img/img_guanyu_women_gongsi_jianjie.44b6abf9.png";